/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseProfileStatistics } from '../../models/response-profile-statistics';

export interface StatisticsByProfileId$Params {

/**
 * Profile id.
 */
  profileId: number;
}

export function statisticsByProfileId(http: HttpClient, rootUrl: string, params: StatisticsByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseProfileStatistics>> {
  const rb = new RequestBuilder(rootUrl, statisticsByProfileId.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseProfileStatistics>;
    })
  );
}

statisticsByProfileId.PATH = '/rest/profile/{profileId}/statistics';
